import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import ButtonWarning from "../Button-warning";


const TokenDetails = ({ token, isVisible, onClose }) => {
  const handleCloseDetailsClick = () => {
    onClose();
  };
  return (
    <div
      className={`fixed top-0 right-0 bottom-0 left-0 z-[200] overflow-hidden backdrop-blur-[2px] ${
        isVisible ? "flex" : "hidden"
      }`}
    >
      <div
        className={`w-10/12 md:w-1/2 shadow-md z-[200] pb-4 gap-4 flex-col rounded-xl bg-white align-start absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2`}
      >
        {token && (
          <div className="flex justify-center gap-4 pt-4 pb-4 m-auto mb-4 text-2xl font-bold text-white capitalize bg-indigo-600 rounded-t-lg">
            <h1 className="self-center text-2xl font-bold capitalize">
              {token.ticker.replace("-", " ")}
            </h1>
            <img
              src={token.logo}
              alt="test"
              className="w-10 h-10 border border-white rounded-full"
            />
          </div>
        )}
        <div className="flex flex-col items-center justify-around gap-4 md:flex-row">
          <div>
            {token && (
              <>
                <div>
                  <strong>{`Blockchain: `}</strong>
                  {token.blockchain === "binance-smart-chain"
                    ? "BSC"
                    : token.blockchain === "ethereum"
                    ? "Ethereum"
                    : token.blockchain === "polygon-pos"
                    ? "Polygon"
                    : token.blockchain === "avalanche"
                    ? "Avalanche"
                    : token.blockchain}
                </div>
                <div>
                  <strong>{`To Receive: `}</strong>
                  {token.to_receive}
                </div>
                <div>
                  <strong>{`Vesting Date: `}</strong>
                  {token.vestingDate}
                </div>
                <div>
                  <strong>{`Launchpad: `}</strong>
                  {token.launchpad}
                </div>
                <div>
                  <strong>{`Claim Portal: `}</strong>
                  {token.claimPortal !== "Claim Portal" ? (
                    <a
                      href={token.claimPortal}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-indigo-500 underline hover:text-indigo-700"
                      onClick={(e) => {
                        e.preventDefault();
                        window.open(token.claimPortal, "_blank");
                      }}
                    >
                      Link
                    </a>
                  ) : (
                    "None"
                  )}
                </div>
                <div>
                  <strong>{`Payment link: `}</strong>
                  <a
                    href={token.paymentTransaction}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-indigo-500 underline hover:text-indigo-700"
                    onClick={(e) => {
                      e.preventDefault();
                      window.open(token.paymentTransaction, "_blank");
                    }}
                  >
                    Tx
                  </a>
                </div>
              </>
            )}
          </div>
          {token && (
            <div style={{ width: 150, height: 150 }}>
              <CircularProgressbar
                className="text-center"
                styles={buildStyles({
                  pathColor: "rgb(22 163 74)",
                  textColor: "rgb(22 163 74)",
                  trailColor: "white",
                  backgroundColor: "rgb(22 163 74)",
                })}
                value={Number((token.receivedAmount / token.to_receive) * 100)}
                text={`${Number(
                  (token.receivedAmount / token.to_receive) * 100
                ).toFixed(2)}%`}
              />
            </div>
          )}
        </div>

        <div className="flex m-auto mt-6 w-fit md:mt-4">
          {/* <button
            className="block px-5 py-2 mb-4 font-medium text-center text-white duration-150 bg-red-600 rounded-lg w-fit hover:bg-red-500 active:bg-red-700 md:py-3 md:inline md:mr-4 md:mb-0"
            type="button"
            onClick={handleCloseDetailsClick}
          >
            Close
          </button> */}
          <ButtonWarning text={"Close"} func={handleCloseDetailsClick} />
        </div>
      </div>
    </div>
  );
};

export default TokenDetails;
